import React from 'react';
import { LocationsSelectSearchControl } from 'src/components/common/LocationsSelectSearchControl/LocationsSelectSearchControl';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';

export function LocationsSelectSearchControlWrapper(): JSX.Element {
  const { corpData } = useEmployeeFormContext();

  return (
    <LocationsSelectSearchControl
      id="locationId"
      name="locationId"
      rules={{
        ...(corpData.locationsRequired && {
          required: 'Location is required',
        }),
      }}
    />
  );
}
